import React, { Component } from 'react';

//manipulate dom
import ReactDOM from 'react-dom';

//components
import { AutoComplete } from 'primereact/autocomplete';
import { Message } from 'primereact/message';


//generic functions
import {
    isEmpty
} from "../../../functions/generic_functions";

/*
    props:
        multiple => true/false toggles multiple, false by default 
        placeholder => placeholder text
        name => name of the input
        
        className => "other classes for this dropdown"

        onChangeSetParentState => call back function to set the parent state using this state's value

        minlength => min length of the input in chars, default 3
        maxlength => max length of the input in chars, default 100
        autoCompleteUrl => url of the auto complete
        delay => delay between keystrokes to wait before sending a query in ms
        dropdown => true/false displays a button next to the input field when enabled
        scrollHeight => max scroll height of the suggestions panel

        disabled => true/false, disables the component, false by default
        required => true/false, shows validation colors, false by default
 
        value => value of text that is directly set and changes upon parent

        autoCompleteParams { //data for parameter to query for auto complete

        }

        post => true/false
*/

class AutoCompleteTextBox extends Component {

    state = {
        suggestions: [],
        valueSelected: true,
        notFound: false,
    }

    constructor(props) {
        super(props);

        //auto complete function
        this.suggestAutoComplete = this.suggestAutoComplete.bind(this);

        //action handlers
        this.handleOnChange = this.handleOnChange.bind(this);
        this.handleOnBlur = this.handleOnBlur.bind(this);
        this.handleOnSelect = this.handleOnSelect.bind(this);
    }

    /*
    for cari applications
        post parameters {
            email,
            application_id,
            token,
            search_str
        }

        return data {
            status: true/false,
            message {
                foundVal: true/false/null
                suggestions_arr [ //depends on the query
                    {
                        "whatever defined id": 
                        name: "name of label"
                    }
                ]
            }
        }
    */
    //build auto complete list from api
    suggestAutoComplete(event) {
        var search_str = event.query.toLowerCase();
        var url = this.props.autoCompleteUrl;

        //add auto complete parameters to form data
        var form_data = new FormData();
        var autoCompleteParams = this.props.autoCompleteParams;
        if (!isEmpty(autoCompleteParams)) {
            for (var paramKey in autoCompleteParams) {
                form_data.append(paramKey, autoCompleteParams[paramKey])
            }
        }

        //add search string
        form_data.append("search_str", search_str);

        fetch(url, {
            method: "POST",
            body: form_data,
            headers: {
                'Accept': 'application/json',
            }
        }).then(response => response.json())
            .then(json => {
                //found data
                if (json.status
                    && !isEmpty(json)
                ) {
                    let fetchedArr = JSON.parse(json.message);
                    let foundVal = fetchedArr.foundVal;
                    let suggestionArr = fetchedArr.suggestion_arr;

                    //if the exact value is found
                    // if (!isEmpty(foundVal)) {
                    //     //clear the suggestions and set the value and state as selected
                    //     this.setState({
                    //         suggestions: undefined,
                    //         valueSelected: true,
                    //     });

                    //     //set the value in the parent component if it is selected
                    //     if (!isEmpty(this.props.onChangeSetParentState)) {
                    //         this.props.onChangeSetParentState(foundVal, this.props.name);
                    //     }
                    // }
                    // //if the value is not found
                    // else {
                    //set the suggestions array with fetched array
                    if (!isEmpty(suggestionArr.length)) {
                        this.setState({
                            notFound: false,
                            suggestions: suggestionArr,
                            valueSelected: false,
                        });
                    }
                    // }
                }
                //no results found
                else {
                    this.setState({
                        suggestions: [],
                        notFound: true,
                        valueSelected: false,
                    });
                }
            })
            //if api is not found
            .catch((error) => {
                console.log(error);
            });
    }

    handleOnChange(event) {
        var currVal = event.target.value;

        if (!isEmpty(this.props.onChangeSetParentState)) {
            this.props.onChangeSetParentState(currVal, this.props.name);
        }

        //if it is selected, set selected to false after changing text
        if (this.state.valueSelected) {
            this.setState({
                valueSelected: false,
            })
        }
    }

    handleOnBlur(event) {
        //if value is not selected and not found, clear value
        if (this.state.notFound || !this.state.valueSelected) {
            //clear the parent data
            if (!isEmpty(this.props.onChangeSetParentState)) {
                this.props.onChangeSetParentState("", this.props.name);
            }
        }
        //clear not found message
        this.setState({
            notFound: false,
        });
    }



    handleOnSelect(event) {
        //on select set not found to false
        this.setState({
            notFound: false,
            valueSelected: true,
        });
    }

    componentDidMount() {
        //grab the auto complete to find the input element with a required tag
        var autocomplete_arr = ReactDOM.findDOMNode(this).getElementsByClassName('autocomplete_textbox');

        //set the autocomplete_arr value here with a required attribute
        for (var key in autocomplete_arr) {
            autocomplete_arr[key].setAttribute("required", true);
            break;
        }
    }

    render() {
        return (
            <React.Fragment>
                <AutoComplete
                    value={this.props.value}
                    placeholder={this.props.placeholder}
                    suggestions={this.state.suggestions}
                    completeMethod={(e) => this.suggestAutoComplete(e)}
                    delay={this.props.delay}
                    className={this.props.disabled ? "disabled_input_box_format": "input_box_format"}
                    inputClassName={this.props.disabled ? "autocomplete_textbox disabled_input_box_format ": "autocomplete_textbox input_box_format " + ((!isEmpty(this.props.className)) ? this.props.className : "")}
                    minLength={(!isEmpty(this.props.minLength) ? this.props.minLength : 3)}
                    maxLength={(!isEmpty(this.props.maxLength) ? this.props.maxLength : 100)}
                    required={(!isEmpty(this.props.required) ? this.props.required : false)}
                    disabled={(!isEmpty(this.props.disabled) ? this.props.disabled : false)}
                    multiple={(!isEmpty(this.props.multiple) ? this.props.multiple : false)}
                    onChange={(e) => this.handleOnChange(e)}
                    onBlur={(e) => this.handleOnBlur(e)}
                    onSelect={(e) => this.handleOnSelect(e)}
                    name={this.props.name}
                />
                {(this.state.notFound) ?
                    <span className={"autocomplete_error_msg_padding"}>
                        <Message severity="error" text="No Results Found" />
                    </span>
                    : null}
            </React.Fragment>
        );
    }
}

export default AutoCompleteTextBox;